document.addEventListener("DOMContentLoaded", () => {
  if (!window.lessonStartTimes || !window.productVariants) return;

  const selectEl = document.querySelector("[name='id']");
  if (!selectEl) return;

  const mainBtn = document.querySelector(
    ".product-page-info__button-add-to-cart [data-js-product-button-add-to-cart]"
  );

  const footBtn = document.querySelector(
    ".footbar-product__button-add-to-cart [data-js-product-button-add-to-cart]"
  );

  const directBtn = document.querySelector(
    ".product-page-info__button-direct-checkout [data-js-product-button-direct-checkout]"
  );

  const DISABLE_MIN_BEFORE = 10;
  const DISABLED_TEXT = "購入期限が過ぎました";
  const BTN_DISABLED_CLASS = "disable-before-lesson";
  const OPT_DISABLED_CLASS = "option-expired";

  const style = document.createElement("style");
  style.textContent = `
    .${BTN_DISABLED_CLASS} {
      pointer-events: none !important;
      background-color: #d8d8d8 !important;
      border-color: #d8d8d8 !important;
      color: #ffffff !important;
      opacity: 1 !important;
    }

    .${OPT_DISABLED_CLASS} {
      background-color: #e0e0e0 !important;
      border-color: #e0e0e0 !important;
      color: #ffffff !important;
      opacity: 1 !important;
    }
  `;
  document.head.appendChild(style);


  // 正規化
  function normalize(str) {
    if (!str) return "";
    return String(str).replace(/[:：\s]/g, "").trim();
  }


  // 日付オプションがどの option に入っているか判定
  function detectDateOptionIndex() {
    const sampleCols = [1, 2, 3].map(i =>
      window.productVariants.map(v => v[`option${i}`])
    );

    const isDateLike = text =>
      typeof text === "string" &&
      (/\d{1,2}月/.test(text) || /\d{1,2}:\d{2}/.test(text) || /〜/.test(text));

    for (let i = 1; i <= 3; i++) {
      if (sampleCols[i - 1].some(isDateLike)) return i;
    }
    return null;
  }

  const dateOptionIndex = detectDateOptionIndex();
  if (!dateOptionIndex) return;


  /* ----------------------------------------------------
      ボタン制御（本体/フッターバー共通）
  ---------------------------------------------------- */
  function applyButtonStatusTo(buttonEl, variantId, mode = "main") {
    if (!buttonEl) return;

    const start = window.lessonStartTimes[variantId];
    if (!start) return;

    const diffMin = (new Date(start) - new Date()) / 60000;

    // 本体（カートに入れる）は通常文言も .btn__text
    const mainTextEl = mode === "main"
      ? buttonEl.querySelector(".btn__text")
      : null;

    // フッターバー（通常）
    const normalTextSpan = mode === "footbar"
      ? buttonEl.querySelector(".text-nowrap:not([data-button-content])")
      : null;

    // 直接チェックアウトボタン（今すぐ申し込む／今すぐ無料講座に申し込む）: 文言は書き換えず非表示にする
    // 「カートに入れる」側に既に「購入期限が過ぎました」が出るため、2つ並べない
    const directWrapper = mode === "direct"
      ? buttonEl.closest(".product-page-info__button-direct-checkout")
      : null;

    // 予約注文（pre-order）
    const preorderTextEl =
      buttonEl.querySelector("[data-button-content='pre-order'] .btn__text");

    if (diffMin <= DISABLE_MIN_BEFORE) {
      buttonEl.classList.add(BTN_DISABLED_CLASS);
      buttonEl.disabled = true;

      if (mainTextEl) {
        mainTextEl.dataset.originalText ||= mainTextEl.textContent;
        mainTextEl.textContent = DISABLED_TEXT;
      }

      if (normalTextSpan) {
        normalTextSpan.dataset.originalText ||= normalTextSpan.textContent;
        normalTextSpan.textContent = DISABLED_TEXT;
      }

      if (directWrapper) {
        directWrapper.classList.add("d-none");
      }

      if (preorderTextEl) {
        preorderTextEl.dataset.originalText ||= preorderTextEl.textContent;
        preorderTextEl.textContent = DISABLED_TEXT;
      }

    } else {
      buttonEl.classList.remove(BTN_DISABLED_CLASS);
      buttonEl.disabled = false;

      if (mainTextEl && mainTextEl.dataset.originalText) {
        mainTextEl.textContent = mainTextEl.dataset.originalText;
      }

      if (normalTextSpan && normalTextSpan.dataset.originalText) {
        normalTextSpan.textContent = normalTextSpan.dataset.originalText;
      }

      if (directWrapper) {
        directWrapper.classList.remove("d-none");
      }

      if (preorderTextEl && preorderTextEl.dataset.originalText) {
        preorderTextEl.textContent = preorderTextEl.dataset.originalText;
      }
    }
  }


  /* ----------------------------------------------------
      オプション枠のグレーアウト
  ---------------------------------------------------- */
  function applyOptionStatus() {
    const optionEls = document.querySelectorAll(
      ".product-options__value.product-options__value--text"
    );

    optionEls.forEach(el => {
      const raw = el.dataset.value;
      if (!raw) return;

      const normKey = normalize(raw);

      const variant = window.productVariants.find(v =>
        normalize(v[`option${dateOptionIndex}`]) === normKey
      );

      if (!variant) return;

      const start = window.lessonStartTimes[variant.id];
      if (!start) return;

      const diffMin = (new Date(start) - new Date()) / 60000;

      if (diffMin <= DISABLE_MIN_BEFORE) {
        el.classList.add(OPT_DISABLED_CLASS);
      } else {
        el.classList.remove(OPT_DISABLED_CLASS);
      }
    });
  }


  /* ----------------------------------------------------
      UI更新
  ---------------------------------------------------- */
  function updateUI() {
    const variantId = selectEl.value;
    if (!variantId) return;

    setTimeout(() => {
      applyButtonStatusTo(mainBtn, variantId, "main");
      applyButtonStatusTo(footBtn, variantId, "footbar");
      applyButtonStatusTo(directBtn, variantId, "direct");
      applyOptionStatus();
    }, 0);
  }


  updateUI();
  selectEl.addEventListener("change", updateUI);


  /* ----------------------------------------------------
      再レンダリング対策（PC オプションUI）
  ---------------------------------------------------- */
  const container = document.querySelector(".product-page-info__options");
  if (container) {
    const observer = new MutationObserver(() => applyOptionStatus());
    observer.observe(container, { childList: true, subtree: true });
  }
});
